import React from 'react';
import { HtmlComponent } from 'features/HtmlComponent';
import { Block, CenteredBlockInner } from 'blocks/components';
import { colors as Colors } from 'constants/colors';
import { FlexContainer } from 'components/flex';
import './style.css';

export default class UpsaleForms extends React.Component {

    render() {
        const { mainBody } = this.props;

        return (
            <Block formpadding marginbottom background={Colors.GRAY}>
                <CenteredBlockInner nopadding wideForm id="formLink">
                    <FlexContainer column margin="0.5rem 0 1rem 0">
                        <div className="UpsaleForm">
                            <HtmlComponent html={mainBody} />
                        </div>
                    </FlexContainer>
                </CenteredBlockInner>
            </Block>
        )
    }
}